<div class="container contenedor-contacto">
    <h2>Contacto</h2>
    <hr>
    
    <div class="row contacto container-sm-fluid container">
    <div class="mb-5 col-12 animated fadeIn fast">
      <form autocomplete="off" [formGroup]="forma" (ngSubmit)="guardar()" action="marco3islas@gmail.com">
    <label for="name" class="form-label text-light">Nombre</label>
    <input
    type="text" 
    class="form-control" 
    id="name"
    formControlName="name" 
    [class.is-invalid]='nameNoValido'
    aria-describedby="name">
    <div id="name" class="form-text">Nunca compartiremos tus datos con alguien.</div>
    <small *ngIf="nameNoValido" class="text-danger">Ingresa tu nombre con un minimo de 5 letras</small>
    
    <label for="email" class="form-label text-light">Email address</label>
    <input 
    type="email" 
    class="form-control" 
    id="email" 
    formControlName="email" 
    [class.is-invalid]='emailNoValido'
    aria-describedby="emailHelp">
    <small *ngIf="emailNoValido" class="text-danger">Ingresa un email Valido</small>

    <label for="comentarios" class="form-label text-light">Comentarios</label>
    <textarea 
      class="form-control" 
      formControlName="comentarios"
      [class.is-invalid]='comentariosNoValido'
      id="comentarios">
    </textarea>
      <small *ngIf="comentariosNoValido" class="text-danger">Ingresa al menos
        tres palabras </small>
  </form>
  <button type="submit" class="btn btn-primary mt-3">Enviar</button>
  </div>
  <div class=" mt-5 col-12 datosContacto container-fluid py-4 align-items-center">
    <div class="info email">
      <span class="fa fa-envelope"> 
      </span>
        marco3islas
        <span class="fas fa-at"></span>
        <span class="fab fa-google"></span>mail.com
    </div>
    <div class="info telegram"><span class="fab fa-telegram"></span> 55 50 69 31 86 </div>
    <div class="info github"> <span class="fab fa-github"></span> https://github.com/marco3islas</div>
  </div>
  </div>
</div>
